import { Moment } from '../../assets/js/src/scripts.js';
import { MomentTimezone } from 'moment-timezone';
import { default as utils } from '../../assets/js/src/utils.js';

function init(getServerTime) {

	window.$ = window.jQuery;

	var $closingTimers = $('.closing-timer');

	if (!$closingTimers.length) {
		return;
	}

	$closingTimers.each(function() {
		new ClosingTimer(getServerTime, $(this));
	});

}

class ClosingTimer {

	constructor(getServerTime, $closingTimer) {

		var openingHours;
		var now;
		var secondsUntilFullMin;
		var dfd = (getServerTime) ? utils.getServerDate() : $.when('');

		try {
			openingHours = JSON.parse($closingTimer.find('.closing-timer__data').html());
		} catch (e) {
			// console.warn('Parsing opening hours failed. Check values.');
			return;
		}

		dfd.then(function(date) {

			now = (date) ? Moment(date).tz('Europe/Helsinki') : Moment().tz('Europe/Helsinki');
			secondsUntilFullMin = 60 - now.seconds();

			// Set initial time
			setTime(now, $closingTimer, openingHours);

			// Update time after first minute is full. This first update takes less than a minute.
			// E.g. if time was 10:34:35 on load, update the timer after 25 seconds, when time hits 10:35:00
			setTimeout(function() {

				now.add(1, 'm');
				setTime(now, $closingTimer, openingHours);

				// Update time in minute intervals
				setInterval(function() {
					now.add(1, 'm');
					setTime(now, $closingTimer, openingHours);
				}, 60000);

			}, secondsUntilFullMin * 1000);

			$closingTimer.addClass('is-ready');

		});

	}

}


function setTime(now, $closingTimer, openingHours) {

	var todayData;
	var isTodayException = false;
	var isClosed = false;
	var openingTime;
	var closingTime;
	var untilClose;
	var untilOpen;
	var hhmmss;
	var $title = $closingTimer.find('h6');

	// Check if today is an exception
	if (openingHours.exceptions) {
		openingHours.exceptions.forEach(function(val, idx) {
			if (now.isSame(val.date, 'day')) {
				isTodayException = true;
				todayData = [val.time_open, val.time_close];
				isClosed = val.closed;
			}
		});
	}

	// Not an exception, use default values
	if (!isTodayException) {
		if (now.day() === 0) {
			todayData = openingHours.sunday;
		} else if (now.day() === 6) {
			todayData = openingHours.saturday;
		} else {
			todayData = openingHours.weekday;
		}
	}

	if (todayData[0] === 0 && todayData[1] === 0) {
		isClosed = true;
	}

	// Set today's opening/closing times
	openingTime = Moment(now);
	openingTime.hours(String(todayData[0]).split(':')[0]);
	openingTime.minutes(String(todayData[0]).split(':')[1] || 0);

	closingTime = Moment(now);
	closingTime.hours(String(todayData[1]).split(':')[0]);
	closingTime.minutes(String(todayData[1]).split(':')[1] || 0);

	// Get the difference from now to opening/closing
	untilClose = closingTime.diff(now);
	untilOpen = openingTime.diff(now);

	if (untilClose < 0 || isClosed) {
		// Closed for today (late already, or an exception day). Show "closed" message.
		$title.find('span').text($title.data('text-closed') + '.');
		$closingTimer.find('p').hide();
	} else {

		if (untilOpen > 0) {
			// Not yet open today. Show time until opening.
			hhmmss = msToTime(untilOpen);
			$title.find('span').text($title.data('text-opens') + ':');
		} else {
			// Open! Show time until closing.
			hhmmss = msToTime(untilClose);
			$title.find('span').text($title.data('text-closes') + ':');
		}

		$closingTimer.find('p').show();
		$closingTimer.find('.closing-timer__hours').text(hhmmss.hh);
		$closingTimer.find('.closing-timer__minutes').text(hhmmss.mm);

	}

	// console.log(todayData, isTodayException, now.day(), window.openingHoursExceptions);

	/**
	 * Dynamic clock
	 * Basically an SVG pie, with a slice defined in 1 hour steps, calculated from 0-point at 12 o'clock position.
	 */
	var $clock = $closingTimer.find('.closing-timer__clock.clock--dynamic');
	var openingTimeStep = getTimeStep(openingTime);
	var currentTimeStep = getTimeStep(now);
	var closingTimeStep = getTimeStep(closingTime);
	// Opening at 9 & closing at 21 should show a full circle, but without some offset a small slice is visible.
	var renderingGlitchOffset = 0.1;

	var sliceStart = openingTime.diff(now) > 0 ? (openingTimeStep - renderingGlitchOffset) : currentTimeStep;
	var sliceEnd = closingTimeStep;

	// MS Edge doesn't work with dynamic CSS Variables here :( Have to calculate fixed values.
	// $closingTimer.get(0).style.setProperty('--opening-hours-current', sliceStart);
	// $closingTimer.get(0).style.setProperty('--opening-hours-end', sliceEnd);

	var sliceStartFixed = (100 / 12 * sliceStart) / 100 - 0.25;
	var sliceEndFixed = sliceStart > sliceEnd
											? 0
											: 100 / 12 * (sliceEnd + (sliceStart * -1));

	$clock.find('svg').css('transform', `rotate(${sliceStartFixed}turn)`);
	$clock.find('circle').css('stroke-dasharray', `${sliceEndFixed}px 100px`);

}

function getTimeStep(time) {
	var h = time.hours();
	var m = time.minutes();
	var step = 0;

	if (h < 12) {
		step = -(12 - h);
		if (m) {
			step = step - (1 - m / 60) + 1;
		}
	} else {
		step = h - 12;
		if (m) {
			step = step + (m / 60);
		}
	}

	return step;
}


// http://stackoverflow.com/questions/19700283/how-to-convert-time-milliseconds-to-hours-min-sec-format-in-javascript
function msToTime(duration) {

	var milliseconds = parseInt((duration % 1000) / 100, 10);
	var seconds = parseInt((duration / 1000) % 60, 10);
	var minutes = parseInt((duration / (1000 * 60)) % 60, 10);
	var hours = parseInt((duration / (1000 * 60 * 60)) % 24, 10);

	// hours = (hours < 10) ? '0' + hours : hours;
	minutes = (minutes < 10) ? '0' + minutes : minutes;
	seconds = (seconds < 10) ? '0' + seconds : seconds;

	return {
		hh: hours,
		mm: minutes,
		ss: seconds,
		ms: milliseconds
	};

}

export default {
	init: init
};
